var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th',{attrs:{"colspan":"5"}}),_c('th',{attrs:{"colspan":"2"}},[_vm._v("Customer Digital Gold Purchase")]),_c('th',{attrs:{"colspan":"2"}},[_vm._v("Customer Digital Gold Sales")]),_c('th',{attrs:{"colspan":"2"}},[_vm._v("Customer Transfer")]),_c('th',{attrs:{"colspan":"2"}},[_vm._v("Customer Minting Gold")]),_c('th')])
}]

export { render, staticRenderFns }